// src/components/CompanyValues.js
import React from 'react';

const CompanyValues = ({ values }) => {
  return (
    <div className="mb-16">
      <h3 className="text-2xl md:text-3xl font-bold text-center mb-3" style={{ color: 'white' }}>
        Principios y <span style={{ color: '#E8B00C' }}>Valores</span>
      </h3>
      <p className="text-center text-gray-400 mb-8 text-base">Los pilares que guían nuestro trabajo diario</p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {values.map((value, index) => (
          <div 
            key={index}
            className="rounded-xl p-6 shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl border-l-4"
            style={{ backgroundColor: '#211F1F', borderLeftColor: '#E8B00C', borderColor: '#333' }}
          >
            <div className="text-3xl mb-3">{value.icon}</div>
            <h4 className="text-lg md:text-xl font-bold mb-2" style={{ color: '#E8B00C' }}>{value.title}</h4>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed text-justify">{value.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyValues;